import { fetchApi } from '@/lib/utils';

import type { IUser } from '@enl/type-definitions';

export class UserService {
  static urls = {
    getMe() {
      return `/v1/auth/users/me`;
    },
    updateMe() {
      return `/v1/auth/users/me`;
    },
  };

  static async getMe() {
    const { data } = await fetchApi<{ data: IUser }>(this.urls.getMe());
    return data;
  }

  static async updateMe(payload: Pick<IUser, 'firstName' | 'lastName' | 'phone' | 'avatar'>) {
    const { data } = await fetchApi<{ data: IUser }>(this.urls.updateMe(), {
      method: 'PATCH',
      data: payload,
    });
    return data;
  }
}
